import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=13ed5c02"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"
import style0 from "./actions-column.vue?vue&type=style&index=0&id=13ed5c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports